import React, { FC, useEffect, useState } from "react";

import EstimatedProduction from "@assets/Estimated Production.svg";
import MonthlyBudget from "@assets/Monthly Budget.svg";
import Appointments from "@assets/Appointments.svg";
import ScheduledNewPatients from "@assets/Scheduled New Patients.svg";

import "./dayMasterCards.scss";
import dashboardService from "@services/dashboard.service";
import { useCalenderViewStore } from "@stores/useCalenderViewStore";
import { forEach } from "lodash";

const DayMasterCards: FC<any> = () => {

    const selectedDateCalender = useCalenderViewStore((state) => state.selectedDateCalender);
    const masterDayData = useCalenderViewStore((state) => state.masterDayData);
    const setMasterDayData = useCalenderViewStore((state) => state.setMasterDayData);
    const [dayViewMasterLoader, setDayViewMasterLoader] = useState<boolean>(false);
    const dayFilter = useCalenderViewStore((state) => state.dayFilter);
    const officeId = useCalenderViewStore((state) => state.officeId);
    const applyFilterFlag = useCalenderViewStore((state) => state.applyFilterFlag);

    
    const getDayViewMasterData = () => {
        console.log("DayMasterCards.getDayViewMasterData"); 
        let filters: { filterType: string; filterValues: any; }[] = [];

          forEach(Object.keys(dayFilter), (filterData)=>{
            if(dayFilter[filterData].length>0){
                filters.push({
                    filterType:filterData,
                    filterValues:dayFilter[filterData]
                  })
            }
          })
        let appointmentDate = selectedDateCalender.format("YYYY-MM-DD");
        let officeID = officeId;
        setDayViewMasterLoader(true);
        dashboardService.fetchCalenderDayViewMasterData(appointmentDate,officeID,filters).subscribe({
            next: (v) => {
                setMasterDayData(v?.data?.data?.masterCardInfo);
                setDayViewMasterLoader(false);
            },

            error: (e) => {
                console.log(e);
                setDayViewMasterLoader(false);
            },
            }
        )
    }

    useEffect(()=> {
        console.log("DayMasterCards.useEffect"); 
        getDayViewMasterData();
     // eslint-disable-next-line react-hooks/exhaustive-deps
     },[selectedDateCalender,applyFilterFlag]);
    
    return (
        dayViewMasterLoader ? <div className="DayKPICards">
        <div className="calenderViewCard">
            <div className="calenderViewCard__icon_preloader shimmerBG"></div>
            <div className="calenderViewCard__body">
                <div className="calenderViewCard__body__info">
                    <div className="calenderViewCard__body__info__title calenderViewCard__body__info__title__preloader shimmerBG"></div>
                    <div className="calenderViewCard__body__info__body__preloader shimmerBG"></div>
                </div>
            </div>
        </div>
        <div className="calenderViewCard">
            <div className="calenderViewCard__icon_preloader shimmerBG"></div>
            <div className="calenderViewCard__body">
                <div className="calenderViewCard__body__info">
                    <div className="calenderViewCard__body__info__title calenderViewCard__body__info__title__preloader shimmerBG"></div>
                    <div className="calenderViewCard__body__info__body__preloader shimmerBG"></div>
                </div>
            </div>
        </div>
        <div className="calenderViewCard">
            <div className="calenderViewCard__icon_preloader shimmerBG"></div>
            <div className="calenderViewCard__body">
                <div className="calenderViewCard__body__info">
                    <div className="calenderViewCard__body__info__title calenderViewCard__body__info__title__preloader shimmerBG"></div>
                    <div className="calenderViewCard__body__info__body__preloader shimmerBG"></div>
                </div>
            </div>
        </div>
        <div className="calenderViewCard">
            <div className="calenderViewCard__icon_preloader shimmerBG"></div>
            <div className="calenderViewCard__body">
            <div className="calenderViewCard__body__info">
                    <div className="calenderViewCard__body__info__title calenderViewCard__body__info__title__preloader shimmerBG"></div>
                    <div className="calenderViewCard__body__info__body__preloader shimmerBG"></div>
                </div>
                <div className="calenderViewCard__body__extraInfo calenderViewCard__body__extraInfo__preloader shimmerBG"></div>
            </div>
        </div>
    </div>  : <div className="DayKPICards">
            <div className="calenderViewCard">
                <div className="calenderViewCard__icon">
                    <img src={EstimatedProduction} alt=""/>
                </div>
                <div className="calenderViewCard__body">
                    <div className="calenderViewCard__body__info">
                        <div className="calenderViewCard__body__info__title">Scheduled Amount</div>
                        <div className="calenderViewCard__body__info__body">{masterDayData!=="No Data Found" ? `$ ${ Math.round(masterDayData?.scheduledAmount)?.toLocaleString()}`: "No Data"}</div>
                    </div>
                </div>
            </div>
            <div className="calenderViewCard">
                <div className="calenderViewCard__icon">
                    <img src={MonthlyBudget} alt=""/>
                </div>
                <div className="calenderViewCard__body">
                    <div className="calenderViewCard__body__info">
                        <div className="calenderViewCard__body__info__title">Budget</div>
                        <div className="calenderViewCard__body__info__body">{masterDayData!=="No Data Found" ? `$ ${ Math.round(masterDayData?.budget)?.toLocaleString()}`: "No Data"}</div>
                    </div>
                </div>
            </div>
            <div className="calenderViewCard">
                <div className="calenderViewCard__icon">
                    <img src={Appointments} alt=""/>
                </div>
                <div className="calenderViewCard__body">
                    <div className="calenderViewCard__body__info">
                        <div className="calenderViewCard__body__info__title">Appointments</div>
                        <div className="calenderViewCard__body__info__body">{masterDayData!=="No Data Found" ? `${ masterDayData?.appointments?.toLocaleString()}`: "No Data"}</div>
                    </div>
                </div>
            </div>
            <div className="calenderViewCard">
                <div className="calenderViewCard__icon">
                    <img src={ScheduledNewPatients} alt=""/>
                </div>
                <div className="calenderViewCard__body">
                    <div className="calenderViewCard__body__info">
                        <div className="calenderViewCard__body__info__title">Scheduled New Patients</div>
                        <div className="calenderViewCard__body__info__body">{masterDayData!=="No Data Found" ? `${ masterDayData?.newPatients?.toLocaleString()}`: "No Data"}</div>
                    </div>
                    <div className="calenderViewCard__body__extraInfo">Existing Patients {masterDayData!=="No Data Found" ? `${masterDayData?.existingPatients?.toLocaleString()}`: "No Data"}</div>
                </div>
            </div>
        </div>
    )
}

export default DayMasterCards;